const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';

export const setPostAuthRedirect = (): void => {
  const fullPath = window.location.pathname + window.location.search;
  window.sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, fullPath);
};

export const handlePostAuthRedirect = (): void => {
  const redirectPath = window.sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  if (redirectPath && redirectPath !== window.location.pathname + window.location.search) {
    window.sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
    window.location.href = redirectPath;
  }
};
